import React from 'react'
import { toApproveApi } from '../../Constants';
import ApprovalQueue from './ApprovalQueue';

function VerificationList() {
  return (
    <ApprovalQueue
      apiUrl={toApproveApi + "/false"}
      title="New attorneys awaiting verification"
      subtitle="Attorneys who've submitted their profile for verification — they can request cases once approved."
    />
  )
}

export default VerificationList
